export default __webpack_public_path__ + "static/media/volume-no.fb99d22e.svg";